
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { CardContent, CardFooter } from '@/components/ui/card';

interface EnrichmentFormProps {
  companyName: string;
  setCompanyName: (value: string) => void;
  companyWebsite: string;
  setCompanyWebsite: (value: string) => void;
  onEnrichment: () => void;
  isPending: boolean;
}

export function EnrichmentForm({
  companyName,
  setCompanyName,
  companyWebsite,
  setCompanyWebsite,
  onEnrichment,
  isPending
}: EnrichmentFormProps) {
  return (
    <>
      <CardContent className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Company Name</label>
          <Input 
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="e.g., Microsoft"
            className="w-full"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Company Website (optional)</label>
          <Input 
            value={companyWebsite}
            onChange={(e) => setCompanyWebsite(e.target.value)}
            placeholder="e.g., microsoft.com"
            className="w-full"
          />
        </div>
      </CardContent>
      <CardFooter className="flex flex-col items-start space-y-4">
        <Button 
          onClick={onEnrichment} 
          disabled={isPending || !companyName}
        >
          {isPending ? 'Processing...' : 'Test Company Enrichment'}
        </Button>
      </CardFooter>
    </>
  );
}
